import { useState } from 'react';
import { faqItems } from '@/mocks/comics';

export default function FAQSection() {
  const [openId, setOpenId] = useState<number | null>(null);

  return (
    <section className="py-14 md:py-20 bg-background-100/70">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            常见问题
          </h2>
          <p className="text-sm text-foreground-500 mt-2">关于韩漫在线的常见疑问解答</p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 rounded-lg border border-background-200 overflow-hidden transition-all duration-200"
            >
              <button
                onClick={() => setOpenId(openId === item.id ? null : item.id)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
              >
                <span className="text-sm font-semibold text-foreground-800 pr-4">{item.question}</span>
                <i
                  className={`ri-arrow-down-s-line text-foreground-400 transition-transform duration-200 w-5 h-5 flex items-center justify-center flex-shrink-0 ${
                    openId === item.id ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              {openId === item.id && (
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}